import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PromotionalBanner.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import HomeImage from '../../assets/banner_1.jpg';
import Home1Image from '../../assets/banner_2.jpg';
import BannerImage from '../../assets/banner_3.jpg';
import AuthBannerImage from '../../assets/banner_4.jpg';
import api from '../../api';

const PromotionalBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fallback banners if no banners are found in database
  const fallbackBanners = [
    {
      id: 1,
      image: HomeImage,
      title: 'Shape Your Future with UlsaApp',
      subtitle: 'Discover thousands of courses and unlock your potential',
      cta: 'Explore Courses',
      link: '/signup',
    },
    {
      id: 2,
      image: Home1Image,
      title: 'Learn from Industry Experts',
      subtitle: 'Get certified and advance your career with our expert-led courses',
      cta: 'Start Learning',
      link: '/signup',
    },
    {
      id: 3,
      image: BannerImage,
      title: 'Unlock Your Potential',
      subtitle: 'Join millions of learners worldwide and transform your skills',
      cta: 'Get Started',
      link: '/signup',
    },
    {
      id: 4,
      image: AuthBannerImage,
      title: 'Premium Learning Experience',
      subtitle: 'Access exclusive content and personalized learning paths',
      cta: 'Upgrade Now',
      link: '/signup',
    },
  ];

  useEffect(() => {
    fetchBanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const response = await axios.get(api.getBanners);
      if (response.data && response.data.length > 0) {
        // Transform database banners to match the expected format
        const transformedBanners = response.data.map((banner) => ({
          id: banner._id,
          image: `${api.img}${banner.image}`,
          title: banner.heading || banner.message,
          subtitle: banner.message,
          cta: 'Explore Courses',
          link: '/signup',
        }));
        setBanners(transformedBanners);
      } else {
        setBanners(fallbackBanners);
      }
    } catch (error) {
      console.error('Error fetching banners:', error);
      setBanners(fallbackBanners);
    } finally {
      setLoading(false);
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
    setProgress(0); // Reset progress when auto-sliding
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setProgress(0); // Reset progress when manually changing slides
  };

  // Pause auto-slide on hover
  const [isPaused, setIsPaused] = useState(false);
  const [progress, setProgress] = useState(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 2000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaused]);

  // Progress bar for auto-slide
  useEffect(() => {
    if (isPaused) return;

    const duration = 5000; // 5 seconds
    const interval = 50; // Update every 50ms
    const increment = (interval / duration) * 100;

    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          return 0;
        }
        return prev + increment;
      });
    }, interval);

    return () => clearInterval(progressInterval);
  }, [isPaused, currentSlide]);

  if (loading) {
    return (
      <div className="promotional-banner-container">
        <div className="banner-loading">
          <div className="loading-spinner"></div>
          <p>Loading banners...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="promotional-banner-container"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="banner-slider">
        <button className="banner-nav-btn-left banner-prev" onClick={prevSlide}>
          <FaChevronLeft />
        </button>

        <div className="banner-slides">
          {banners.map((banner, index) => (
            <div
              key={banner.id}
              className={`banner-slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${banner.image})`,
                transform: `translateX(${(index - currentSlide) * 100}%)`,
              }}
            >
              <div className="banner-overlay">
                <div className="banner-content">
                  <h2 className="PromotionalBanner-banner-title">{banner.title}</h2>
                  <p className="banner-subtitle">{banner.subtitle}</p>
                  <button
                    className="banner-cta"
                    onClick={() => navigate(banner.link)}
                  >
                    {banner.cta}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="banner-nav-btn-right banner-next" onClick={nextSlide}>
          <FaChevronRight />
        </button>
      </div>

      <div className="banner-indicators">
        {banners.map((_, index) => (
          <button
            key={index}
            className={`banner-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>

      {/* Progress Bar */}
      <div className="banner-progress">
        <div
          className="banner-progress-bar"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default PromotionalBanner; 